/* ============================================================
   Apolnus 捲動進場(原生)— 僅手機/觸控裝置執行
   桌機走游標特效(onex-fx),兩邊分開、不過載。
   IntersectionObserver 批次錯落;data-osr 由 JS 加 → JS失效時內容仍顯示。
   ============================================================ */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* 只在「無 hover 的觸控裝置」(手機/平板)跑捲動進場;桌機用游標特效 */
  if (!(window.matchMedia && window.matchMedia('(hover: none)').matches)) return;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    /* 政策頁（.shopify-policy__*）不做進場動畫：法務文件直接顯示。
       2026-08-25 移除——body 整塊 reveal 在超長頁（特商法）可見比例永達不到
       threshold 0.12＝手機永久白屏；中長頁（隱私/規約）滑動才出字。 */
    var sel = '.faqx__hero, .faqx__cat, .faqx__item, .faqx__cta, .product-card';
    var els = Array.prototype.slice.call(document.querySelectorAll(sel));
    if (!els.length) return;
    els.forEach(function (el) { el.setAttribute('data-osr', ''); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var batch = entries.filter(function (e) { return e.isIntersecting; });
        batch.forEach(function (e, i) {
          var t = e.target;
          setTimeout(function () { t.classList.add('is-in'); }, Math.min(i, 5) * 80);
          io.unobserve(t);
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }
  });
})();
